import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temasili',
  templateUrl: './temasili.component.html',
  styleUrls: ['./temasili.component.css']
})
export class TemasiliComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
